$(document).ready(function () {
  new Pluswerk.PlusProject.Utility.GenerateShareUrlController();
  new Pluswerk.PlusProject.Content.PriceFootnoteController();
  new Pluswerk.PlusProject.Content.HeaderImageIEController();
  new Pluswerk.PlusProject.CountDown.CountDownController();
  new Pluswerk.PlusProject.CountDownPlugin.CountDownPluginController();
  // DetectOSController
  new Pluswerk.PlusProject.Utility.DetectOSController();

  // JumpToSectionController
  new Pluswerk.PlusProject.Utility.JumpToSectionController();
  //fe manager was removed
  // new Pluswerk.PlusProject.FeManager.FeUserController();

  Pluswerk.PlusProject.Utility.AccessibilityController.init();

  Pluswerk.PlusProject.Utility.ValidateFormController.init();
  Pluswerk.PlusProject.PlusSolr.AddBackgroundController();
  Pluswerk.PlusProject.Utility.ReplaceUrlSegmentController.init();
  Pluswerk.PlusProject.Form.MagazineParameterHandler();
});
